export default __webpack_public_path__ + "static/media/service-01.da202420.jpg";